export default __webpack_public_path__ + "assets/65f5e587794de1fce3619f97718e5af1.png";